module.exports = __webpack_public_path__ + "img/chevron_up.6766a28.svg";